import { Box } from '@chakra-ui/react'
import { Format } from '@helo/cms'
import { Fragment, type ReactNode, useRef } from 'react'

import { CardHeaderItem } from '../../components/CardContainer/CardHeaderItem'
import { CardHeaderWrapper } from '../../components/CardHeaderWrapper/CardHeaderWrapper'
import { withUnicodeRouteArrow } from '../../utils/routeLabelDisplay'
import { Separator } from '../TransshipmentDwellTiles/Separator'
import { createWidget } from '../widget-utils'

export interface CardHeaderContainerWidgetProps {
  list?: { label: string; value: string }[]
  isLoading?: boolean
  children?: ReactNode
}

/**
 * Note:
 * This widget needs to go away. Naming doesn't make any sense, and it looks like
 * a hack to get some item related data to show up on the item details page.
 *
 * applying a hacky skeleton loader to move past it and not waste time.
 */
export const CardHeaderContainerWidget = ({
  children,
  list,
  isLoading,
  ...props
}: CardHeaderContainerWidgetProps) => {
  const ref = useRef<HTMLDivElement>(null)

  const itemList = (
    isLoading ? Array(2).fill({}) : list
  ) as CardHeaderContainerWidgetProps['list']

  return (
    <Box position="relative" ref={ref}>
      <CardHeaderWrapper backgroundColor="presets.neutral.0" {...props}>
        {itemList?.map(({ label, value }, index) => (
          <Fragment key={index}>
            {index === itemList.length - 1 && <Separator ml="40px" mr="40px" />}
            <CardHeaderItem
              flexGrow={1}
              caption={label}
              value={withUnicodeRouteArrow(Format.text({})(value))}
              isLoading={isLoading}
            />
          </Fragment>
        ))}
      </CardHeaderWrapper>
    </Box>
  )
}

export const CardHeaderContainerWidgetDefinition = createWidget(
  CardHeaderContainerWidget,
  {
    type: 'CardHeaderContainer',
  },
)
